/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Result_Idle_TitleInputs */

const en_tts_tool_result_idle_title = /** @type {(inputs: Tts_Tool_Result_Idle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio preview`)
};

const es_tts_tool_result_idle_title = /** @type {(inputs: Tts_Tool_Result_Idle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa del audio`)
};

/**
* | output |
* | --- |
* | "Audio preview" |
*
* @param {Tts_Tool_Result_Idle_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_result_idle_title = /** @type {((inputs?: Tts_Tool_Result_Idle_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Result_Idle_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_result_idle_title(inputs)
	return en_tts_tool_result_idle_title(inputs)
});